import styled, { css } from 'styled-components';

type LabelProps = {
  size: 'large' | 'small';
  padding?: string;
  color?:
    | 'seedgreen'
    | 'snowwhite'
    | 'amprimary'
    | 'pmprimary'
    | 'dmprimary'
    | 'none';
};

const labelBase = css`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: var(--radius-full);
  padding: 0.5em 0.667em;
  font-family: var(--ff, 'Seed Sans');
  font-size: var(--fz);
  font-style: normal;
  font-weight: 500;
  line-height: 100%; // This is 140% in the figma, but then it doesn't look like the figma. Strange
`;

const getLabelSizeStyles = (size: 'large' | 'small') => {
  switch (size) {
    case 'large':
      return {
        fontSize: 'var(--font-size-350)',
      };
    case 'small':
      return {
        fontSize: 'var(--font-size-300)',
      };
    default:
      throw new Error(`Unsupported Label size: ${size}`);
  }
};

const getLabelColors = (
  color:
    | 'seedgreen'
    | 'snowwhite'
    | 'amprimary'
    | 'pmprimary'
    | 'dmprimary'
    | 'none',
) => {
  switch (color) {
    case 'seedgreen':
      return {
        textColor: 'var(--fill-brand)',
        background: 'var(--guidance-primary)',
      };
    case 'snowwhite':
      return {
        textColor: 'var(--fill-primary)',
        background: 'var(--guidance-primary)',
      };
    case 'amprimary':
      return {
        textColor: 'var(--fill-primary)',
        background: 'var(--products-am-02-dark)',
      };
    case 'pmprimary':
      return {
        textColor: 'var(--fill-primary)',
        background: 'var(--products-pm-02-dark)',
      };
    case 'dmprimary':
      return {
        textColor: 'var(--fill-primary)',
        background: 'var(--products-dm-02-dark)',
      };
    case 'none':
      return {
        textColor: 'var(--fill-brand)',
        background: 'transparent',
      };
    default:
      throw new Error(`Unsupported Label color: ${color}`);
  }
};

const Label = styled.span<LabelProps>`
  ${labelBase}
  ${({ size, color = 'seedgreen', padding }) => {
    const { fontSize } = getLabelSizeStyles(size);
    const { textColor, background } = getLabelColors(color);

    return css`
      --fz: ${fontSize};
      color: ${textColor};
      background: ${background};
      ${padding && `padding: ${padding};`}
    `;
  }}
`;

export default Label;
